import { FC, useEffect, useState } from 'react'

import { useAppSelector } from '../../app/hook'
import { LeaderBoardLayout } from '../../components'
import { appCallbackHandler } from '../../util/AppCallbackHandler'
import { Info, Layout, Rewards, SeasonTabs } from './components'
import { useSearchParams } from 'react-router-dom'
import { SVGs } from '../../assets'

const FDS_REWARDS = [
    {
        id: 1,
        icon: SVGs.FdsToken,
        name: 'FDS',
        base: 1,
        prize_per_user: 1,
        total: 1,
        Product: 'FDS',
        max: 5000,
    },
]

export const SeasonDetail: FC<unknown> = () => {
    const { season } = useAppSelector((state) => state.leaderBoard)
    const [searchParams] = useSearchParams()
    const [region, setRegion] = useState<'th' | 'gl' | undefined>()

    useEffect(() => {
        appCallbackHandler(
            'setToolbarHeaderUI',
            searchParams.get('status') === 'running'
                ? 'Season Detail'
                : 'Pre-Heat'
        )
    }, [])

    useEffect(() => {
        const regionValue = searchParams.get('region')
        setRegion(
            regionValue === 'th' || regionValue === 'gl'
                ? regionValue
                : undefined
        )
    }, [searchParams.get('region')])

    return !region ? (
        <div
            style={{ background: '#090916', width: '100dvw', height: '100dvh' }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    height: '100%',
                    width: '360px',
                    margin: 'auto auto',
                }}
            >
                <img
                    src={SVGs.somethingWentWrong}
                    alt="Something went wrong"
                    width={148}
                    height={148}
                />
                <div
                    style={{ color: '#fff', fontSize: '14px', fontWeight: 700 }}
                >
                    Oops! Something went wrong
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <span
                        style={{
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: 400,
                        }}
                    >
                        We couldn't load the content just now.
                    </span>
                    <span
                        style={{
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: 400,
                        }}
                    >
                        Please try again shortly.
                    </span>
                </div>
                <button
                    style={{
                        marginTop: '16px',
                        padding: '8px 16px',
                        background: '#FCD986',
                        width: '145px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        border: 'none',
                        borderRadius: '4px',
                    }}
                    onClick={() => window.location.reload()}
                >
                    Reload
                </button>
            </div>
        </div>
    ) : (
        <LeaderBoardLayout headerText="Season Details" isSeasonHeaderHidden>
            <Layout>
                {season?.status && (
                    <Info
                        seasonTitle={season?.title}
                        seasonStatus={season?.status}
                        startDate={season?.start_date ? season.start_date : ''}
                    />
                )}

                <Rewards rewards={FDS_REWARDS} />

                {/* {rewards && rewards.length ? (
                   
                ) : null} */}
                <SeasonTabs season={season} />
            </Layout>
        </LeaderBoardLayout>
    )
}
